import { Injectable } from '@angular/core';
import { Observable,of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../models/user';
import { catchError,map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AppService, RTEAlertService,  } from 'rte-library';
import { ObjectGroup } from '../models/objectGroup';
import { UserPermission } from '../models/userPermission';
import { Company } from 'src/app/models/company';
import { Parameter } from '../models/parameter';



@Injectable({
  providedIn: 'root'
})
export class UserService {

  headers = new HttpHeaders({
    'No-loading': 'True'
  });

  constructor(
    private http: HttpClient,
    private alert: RTEAlertService
  ) { }

  generatePassword(id: number): Observable<string> {
    return this.http.get<string>(environment.apiUrl + 'api/user/createnewpassword?userId=' + id)
      .pipe(catchError(this.handleError<string>('generatePassword'))
      );
  }

  sendPassword(id: number): Observable<string> {
    return this.http.post<string>(environment.apiUrl + 'api/user/sendnewpassword?userId=' + id, null)
      .pipe(catchError(this.handleError<string>('sendPassword'))
    );
  }

  getUserById(id: number): Observable<User> {
    return this.http.get<User>(environment.apiUrl + 'api/user/getusersbyid?id=' + id)
      .pipe(catchError(this.handleError<User>('getUserById'))
      );
  }

  getUserByDescription(description: String): Observable<User[]> {
    return this.http.get<User[]>(environment.apiUrl + 'api/user/getusersbydescription?description=' + description, {headers: this.headers})
    .pipe(catchError(this.handleError<User[]>('getUserByDescription', []))
    );
  }

  getUsers(id: number, description: string, login: string, companyId: number, page: number): Observable<User[]> {
    if (id === undefined)
      id = 0;
    if (description === undefined)
      description = '';
    if (login === undefined)
      login = '';
    if (companyId === undefined)
      companyId = 0;
    return this.http.get<User[]>(environment.apiUrl + 'api/user/getusers?Id=' + id + '&description=' + description + '&login=' + login + '&companyId=' + companyId + '&page=' + page)
      .pipe(catchError(this.handleError<User[]>('getUsers',[]))
      );
  }

  save(user: User, permissions: ObjectGroup[], parameters?: Parameter[]): Observable<number> {
    return this.http.post<number>(environment.apiUrl + 'api/user/save', {
      user: user,
      permissions: permissions,
      DeveloperParameters: parameters
    })
      .pipe(catchError(this.handleError<number>('save'))
    );
  }

  saveNewPassword(userCompanyId: number, userId: number, newPassword: string, confirmNewPassword: string): Observable<boolean> {
    return this.http.post<boolean>(environment.apiUrl + 'api/user/savenewpassword', {
      userCompanyId: userCompanyId,
      userId: userId,
      newPassword: newPassword,
      confirmNewPassword: confirmNewPassword
    });
  }

  delete(userId: number, isDeveloper?: boolean): Observable<boolean> {
    if (userId === undefined) {
      userId = 0;
    }

    return this.http.delete<boolean>(environment.apiUrl + 'api/user/delete?userId=' + userId + '&isDeveloper=' + isDeveloper)
      .pipe(catchError(this.handleError<boolean>('delete'))
      );
  }

  getObjectGroup() {
    return this.http.get<ObjectGroup[]>(environment.apiUrl + 'api/user/getallobjectsgroups')
      .pipe(catchError(this.handleError<ObjectGroup[]>('getObjectGroup',[]))
      );
  }

  getUserPermission(userId: number, companyId: number): Observable<UserPermission[]> {
    return this.http.get<UserPermission[]>(environment.apiUrl + 'api/user/getuserpermission?userId=' + userId + '&companyId=' + companyId)
      .pipe(catchError(this.handleError<UserPermission[]>('getUserPermission', []))
      );
  }

  getCompany(): Observable<Company> {
    return this.http.get<Company>(environment.apiUrl + 'api/user/getcurrentusercompany')
      .pipe(catchError(this.handleError<Company>('getCompany'))
      );
  }

  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.Message !== undefined) {
        this.alert.error(error.error.Message);
      }
      else {
        this.alert.error('Não foi possível concluir a solicitação.');
      }
      return of(result as T);
    };
  }


}
